module.exports = {
  "account_page": [
    {
      "language": "de-DE",
      "slug": "/account",
      "robots": "index,follow"
    },
    {
      "language": "en-US",
      "slug": "/en-US/account",
      "robots": "index,follow"
    }
  ],
  "shopping_cart_page": [
    {
      "language": "de-DE",
      "slug": "/shopping-cart",
      "robots": "index,follow"
    },
    {
      "language": "en-US",
      "slug": "/en-US/shopping-cart",
      "robots": "index,follow"
    }
  ],
  "not_found_page": null
}